'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { homePath, useAdminContext } from '@/lib/admin-context';
import { useI18n } from '@/lib/i18n';

export default function AdminHomePage() {
  const { t } = useI18n();
  const router = useRouter();
  const { ready, context } = useAdminContext();
  useEffect(() => {
    if (ready && context) router.replace(homePath(context));
  }, [ready, context, router]);
  return <main className="text-sm text-muted-foreground">{t('Loading…')}</main>;
}
